module.exports = __webpack_public_path__ + "static/media/remember_03.518ea409.png";